import { fetchLogin, fetchOperators, setLogout, setMenuState } from "@actions";
import CloseButton from "@buttons/CloseButton";
import availablePanes from "@helpers/panes";
import ModalContainer from "@modals/ModalContainer";
import OrganisationDirectoryMenu from "@shared/OrganisationDirectoryMenu";
import TimeoutCheck from "@shared/TimeoutCheck";
import React from "react";
import { connect } from "react-redux";
import { Menu, Tab } from "semantic-ui-react";
import DefaultView from "./DefaultView";
import MainMenu from "./MainMenu";
import SystemTray from "./SystemTray";
import { setSection } from "@actions/compliance";

class Panes extends React.Component {
  constructor(props) {
    super(props);

    if (this.props.logIn === "") window.location = "/";

    this.state = {
      availablePanes: this.getAvailablePanes(),
    };
  }

  getAvailablePanes = () => {
    return availablePanes.map(({ key, title, component }) => {
      return {
        menuItem: (
          <Menu.Item key={key}>
            {title} <CloseButton onClose={(e) => this.rmTab(key)} />
          </Menu.Item>
        ),
        pane: <Tab.Pane key={`tab_${key}`}>{component}</Tab.Pane>,
      };
    });
  };

  rmTab = (name) => {
    const panes = this.props.mainMenuState.panes.filter(
      (pane) => pane.menuItem.key !== name,
    );

    let activeIndex = null;
    let section = "";

    if (panes.length) {
      activeIndex = panes.length - 1;
      section = panes[activeIndex].menuItem.key;
    }

    this.props.setMenuState({ panes, activeIndex, section });
  };

  createPane(menuItem) {
    let newPane = this.state.availablePanes.find(
      (pane) => pane.menuItem.key === menuItem,
    );
    if (newPane) {
      const newPanes = [...this.props.mainMenuState.panes, newPane];
      this.props.setMenuState({
        activeIndex: this.props.mainMenuState.panes.length,
        panes: newPanes,
        section: menuItem,
      });
    }
  }

  updateTab = (menuItem) => {
    this.props.setSection(menuItem);
    if (this.props.mainMenuState.panes.length > 0) {
      let pane = this.props.mainMenuState.panes.findIndex(
        (pane) => pane.menuItem.key === menuItem,
      );
      if (pane > -1) {
        this.props.setMenuState({
          activeIndex: pane,
          section: menuItem,
        });
      } else {
        this.createPane(menuItem);
      }
    } else {
      this.createPane(menuItem);
    }
  };

  setPane = () => {
    let pane = 0;
    if (this.props.match.params.id === "current_installations") {
      pane = 1;
    }
    this.props.setMenuState({ activeIndex: pane });
  };

  handleTabChange = (e, { activeIndex }) => {
    this.props.setMenuState({
      activeIndex,
      section: this.props.mainMenuState.panes[activeIndex].menuItem.key,
    });
  };

  componentDidMount() {
    this.props.fetchOperators();
    this.setPane();
    if (this.props.logIn.optionShowSupportWidget) {
      const event = new Event("cms.login.successful");
      document.dispatchEvent(event);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id)
      this.setPane();
  }

  // Add callback function to handle width changes
  handleOrgDirectoryResize = (newWidth) => {
    this.props.setMenuState({ orgDirectoryWidth: newWidth });
  };

  calculateLeftMargin = () => {
    let marginLeft = 0;
    marginLeft += this.props.mainMenuState.collapsed ? 48 : 210;
    marginLeft += !this.isOrgTreeCollapsed()
      ? 0
      : this.props.mainMenuState.orgDirectoryWidth; // Use dynamic width

    return marginLeft;
  };

  isOrgTreeCollapsed = () => {
    switch (this.props.mainMenuState.section) {
      case "GENERAL_SESSIONS":
        return this.props.sessionsFilters.showOrgTree;
      case "GENERAL_TRANS":
        return this.props.transactionsFilters.showOrgTree;
      case "GENERAL_INSTALL":
        return this.props.installationsFilters.showOrgTree;
      case "GENERAL_COMMS":
        return this.props.liveFloorViewerFilters.showOrgTree;
      case "GENERAL_ANALYSIS":
        return this.props.analysisFilters.showOrgTree;
      case "KIOSK":
        return this.props.kioskFilters.showOrgTree;
      case "GENERAL_SYSADMIN":
        return this.props.settingsFilters.showOrgTree;
      case "COMPLIANCE":
        return this.props.complianceFilters.showOrgTree;
      case "CUSTOMERS":
        return this.props.customerFilters.showOrgTree;
      default:
        return false;
    }
  };

  render() {
    const marginLeft = this.calculateLeftMargin();

    return (
      <div className="height-100">
        <TimeoutCheck />
        <ModalContainer />
        <MainMenu
          collapsed={this.props.mainMenuState.collapsed}
          onCollapse={() =>
            this.props.setMenuState({
              collapsed: !this.props.mainMenuState.collapsed,
            })
          }
          onSubmit={this.updateTab}
          onLogout={this.logout}
          menu={this.props.logIn.menu}
        />
        {this.props.mainMenuState.panes.length > 0 && (
          <OrganisationDirectoryMenu
            setActiveFilter={this.setActiveFilter}
            section={this.props.mainMenuState.section}
            marginLeft={this.props.mainMenuState.collapsed ? 48 : 210}
            onWidthChange={this.handleOrgDirectoryResize}
          />
        )}
        <div
          className="height-100 gs-flex-container-vertical"
          style={{
            position: "absolute",
            top: "0",
            marginLeft: `${marginLeft}px`,
            minWidth: "720px",
            width: `calc(100% - ${marginLeft}px)`, // Adjust width dynamically
          }}
        >
          {this.props.mainMenuState.panes.length > 0 ? (
            <div className="flex-stretch" style={{ alignItems: "center" }}>
              <Tab
                panes={this.props.mainMenuState.panes}
                activeIndex={this.props.mainMenuState.activeIndex}
                onTabChange={this.handleTabChange}
                renderActiveOnly={false}
                className="height-100 gs-flex-container-vertical p-half"
              />
            </div>
          ) : (
            <DefaultView />
          )}
          <SystemTray />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    logIn: state.logIn,
    complianceFilters: state.complianceFilters,
    customerFilters: state.customerFilters,
    settingsFilters: state.settingsFilters,
    sessionsFilters: state.sessionsFilters,
    transactionsFilters: state.transactionsFilters,
    installationsFilters: state.installationsFilters,
    kioskFilters: state.kioskFilters,
    analysisFilters: state.analysisFilters,
    liveFloorViewerFilters: state.LiveFloorViewerFilters,
    mainMenuState: state.mainMenuState,
  };
};

export default connect(mapStateToProps, {
  fetchLogin,
  setLogout,
  fetchOperators,
  setSection,
  setMenuState,
})(Panes);
